import { render, staticRenderFns } from "./fox.vue?vue&type=template&id=6fe573bc&scoped=true&"
import script from "./fox.vue?vue&type=script&lang=js&"
export * from "./fox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe573bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabItem,VTabs,VTabsItems})
